"use strict";

var _interopRequireWildcard = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exportOrderExcel = exports.ExportExcelType = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.fill.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.object.entries.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _fileSaver = require("file-saver");
var Excel = _interopRequireWildcard(require("exceljs"));
var _index = require("@/utils/index");
var _string = require("@/utils/string");
var _lodash = require("lodash");
var _order = require("@/types/order");
var ExportExcelType;
(function (ExportExcelType) {
  ExportExcelType["RealPublish"] = "REAL_PUBLISH";
  ExportExcelType["RealNoPublish"] = "REAL_NO_PUBLISH";
  ExportExcelType["Real"] = "REAL";
  ExportExcelType["Accountant"] = "ACCOUNTANT";
})(ExportExcelType || (exports.ExportExcelType = ExportExcelType = {}));
var fontBold = {
  font: {
    bold: true
  }
};
var fontBoldRed = {
  font: {
    bold: true,
    color: {
      argb: "ffff0202"
    }
  }
};
var fontBoldGreen = {
  font: {
    bold: true,
    color: {
      argb: "ff427c27"
    }
  }
};
var border = {
  top: {
    style: "thin",
    color: {
      argb: "#000"
    }
  },
  left: {
    style: "thin",
    color: {
      argb: "#000"
    }
  },
  bottom: {
    style: "thin",
    color: {
      argb: "#000"
    }
  },
  right: {
    style: "thin",
    color: {
      argb: "#000"
    }
  }
};
var row = 0;
var exportOrderExcel = exports.exportOrderExcel = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(_ref) {
    var data, type, fromDate, toDate, fileName, workbook, worksheet, titleCell, startTableRow, startTable, newData, buffer, fileType, fileExtension, blob;
    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          data = _ref.data, type = _ref.type, fromDate = _ref.fromDate, toDate = _ref.toDate;
          // config export excel
          fileName = "Order ".concat(type);
          workbook = new Excel.Workbook();
          worksheet = workbook.addWorksheet("Order", {
            pageSetup: {
              fitToPage: true,
              fitToHeight: 5,
              fitToWidth: 7
            },
            views: [{
              state: 'frozen',
              ySplit: 2
            }]
          }); //set title table
          titleCell = worksheet.getCell('A1');
          if (fromDate && toDate) {
            titleCell.value = "SALE REPORT Date : ".concat(fromDate, " - ").concat(toDate);
          } else {
            titleCell.value = "SALE REPORT";
          }
          titleCell.style = {
            font: {
              color: {
                argb: 'ffFF6600'
              },
              size: 16,
              bold: true
            }
          };
          worksheet.mergeCells('A1:I1');
          //
          //add table
          startTableRow = 1;
          startTable = worksheet.getCell("A".concat(startTableRow++));
          startTable.style = {
            font: {
              color: {
                argb: "ffff0202"
              }
            }
          };
          newData = (0, _lodash.orderBy)(data, ['createdAt'], ['asc']);
          generateTable(worksheet, newData, startTableRow, type);
          generateTableSKU(worksheet, newData, row + 2, type);
          _context.next = 16;
          return workbook.xlsx.writeBuffer();
        case 16:
          buffer = _context.sent;
          fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          fileExtension = ".xlsx";
          blob = new Blob([buffer], {
            type: fileType
          });
          (0, _fileSaver.saveAs)(blob, fileName + fileExtension);
        case 21:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function exportOrderExcel(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var generateTable = function generateTable(worksheet, data, startTableRow, type) {
  //transform data
  var total = {
    quantity: 0,
    wholesalePrice: 0,
    beforeVatPrice: 0,
    vatPrice: 0,
    totalPrice: 0,
    costing: 0,
    shippingChargeByShiratori: 0,
    shippingChargeByCustomer: 0,
    profit: 0,
    paid: 0,
    unpaid: 0
  };
  var collected = {
    collected: 0,
    notCollected: 0,
    totalCollected: 0
  };
  var orders = [];
  data.forEach(function (order) {
    var details = order.orderDetails || order.giveawayDetails;
    var paid = order.orderProgress.paymentAmount;
    details.forEach(function (e) {
      if ((type == ExportExcelType.RealPublish || type == ExportExcelType.Accountant) && !e.isPublished) {
        return;
      }
      if (type != ExportExcelType.Accountant && order.type == _order.OrderType.Gift) {
        return;
      }
      if (type == ExportExcelType.RealNoPublish && e.isPublished) {
        return;
      }
      var customer = order.customer || {
        name: 'GIFT (HÀNG TẶNG KHÔNG THU TIỀN)'
      };
      var shippingChargeByCustomer = order.orderProgress.shippingChargeByCustomer / details.length;
      var shippingChargeByShiratori = e.shippingCharge == order.orderProgress.shippingChargeByShiratori ? e.shippingCharge / details.length : 0;
      var orderProgress = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, order.orderProgress), {}, {
        shippingChargeByShiratori: shippingChargeByShiratori,
        shippingChargeByCustomer: shippingChargeByCustomer,
        paymentAmount: order.orderProgress.paymentAmount
      });
      var paidProduct = paid > 0 ? Math.min(paid, e.totalPrice) : 0;
      paid = Math.abs(paid - paidProduct);
      var vatValue = 1 + order.vatFactor;
      var shopeeFee = Math.round(order.totalShopeeFee / details.length);
      var tmp = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, order), {}, {
        lotNumber: e.lotNumber,
        isPublished: e.isPublished,
        product: e.product,
        customer: customer,
        productOriginPrice: e.originPrice,
        productRetailPrice: e.retailPrice,
        productRealPrice: e.realPrice,
        productQuantity: e.quantity,
        productTotalPrice: e.totalPrice,
        discount: e.discountPercent / 100 || e.discountAmount,
        discountType: e.discountPercent ? "percent" : "amount",
        productBeforeVatPrice: e.totalPrice / vatValue,
        productVatPrice: e.totalPrice / vatValue * order.vatFactor,
        productProfit: e.profit - shopeeFee,
        costing: e.originPrice * e.quantity,
        rowspan: 0,
        orderProgress: orderProgress,
        paid: paidProduct,
        unpaid: e.totalPrice - paidProduct,
        vatFactor: order.vatFactor * 100,
        totalShopeeFee: shopeeFee
      });
      total.paid += paidProduct;
      total.unpaid += e.totalPrice - paidProduct;
      total.quantity += e.quantity;
      total.wholesalePrice += e.realPrice;
      total.beforeVatPrice += e.totalPrice / vatValue;
      total.vatPrice += e.totalPrice / vatValue * order.vatFactor;
      total.totalPrice += e.totalPrice;
      total.costing += e.originPrice * e.quantity;
      total.shippingChargeByShiratori += orderProgress.shippingChargeByShiratori;
      total.shippingChargeByCustomer += orderProgress.shippingChargeByCustomer;
      total.profit += e.profit;
      orders.push(tmp);
    });
  });
  collected.notCollected = total.unpaid;
  collected.collected = total.paid;
  collected.totalCollected = collected.collected + collected.notCollected;
  var count = 0;
  orders.forEach(function (element, index) {
    count++;
    if (index < orders.length - 1 && element.code != orders[index + 1].code) {
      orders[index + 1 - count].rowspan = count;
      count = 0;
    }
  });
  debugger;
  if (orders.length) {
    orders[orders.length - count].rowspan = count;
  }
  orders.push({
    code: "Total",
    productRetailPrice: "Total",
    productRealPrice: total.wholesalePrice,
    productQuantity: total.quantity,
    productTotalPrice: total.totalPrice,
    productBeforeVatPrice: total.beforeVatPrice,
    productVatPrice: total.vatPrice,
    productProfit: total.profit,
    costing: total.costing,
    orderProgress: {
      shippingChargeByShiratori: total.shippingChargeByShiratori,
      shippingChargeByCustomer: total.shippingChargeByCustomer
    },
    paid: total.paid,
    unpaid: total.unpaid,
    rowspan: 0
  });
  var startRow = startTableRow;
  var dataExcel = [{
    value: "Order Code",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "code",
    width: 12,
    mergeRow: true
  }, {
    value: "Date of ordering",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "createdAt",
    format: 'date',
    width: 12,
    mergeRow: true
  }, {
    value: "Customer code",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "customer.code",
    width: 25,
    mergeRow: true
  }, {
    value: "Customer name",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "customer.name",
    width: 25,
    mergeRow: true
  }, {
    value: "SKU",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "product.sku",
    width: 25
  }, {
    value: "Staff",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "staff.name",
    width: 25
  }, {
    value: "Retail Price",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "productRetailPrice",
    numFmt: '#,##0',
    width: 25
  }, {
    value: "Order quantity (box)",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "productQuantity",
    numFmt: '#,##0',
    width: 8
  }, {
    value: "Discount",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: 'discount',
    numFmt: '0%',
    width: 12
  }, {
    value: "Wholesale price",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "productRealPrice",
    numFmt: '#,##0',
    width: 25
  }, {
    value: "Total (-VAT)",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "productBeforeVatPrice",
    numFmt: '#,##0',
    width: 25
  }, {
    value: "VAT",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: 'productVatPrice',
    numFmt: '#,##0.00',
    width: 25
  }, {
    value: "% VAT",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: 'vatFactor',
    numFmt: '#,##0',
    width: 25
  }, {
    value: "Total (+VAT)",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "productTotalPrice",
    numFmt: '#,##0',
    width: 25
  }, {
    value: "Total Shopee Fee (Service Fee, Transaction Fee, Shipping,...)",
    style: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, fontBold), {}, {
      color: {
        argb: "E21616"
      }
    }),
    prop: "totalShopeeFee",
    numFmt: '#,##0',
    width: 25
  }, {
    value: "NOTE",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: 'invoice',
    width: 15,
    mergeCol: true,
    numberMergeCol: 1
  }, {
    value: "NOTE",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: 'invoiceLink',
    width: 12
  }, {
    value: "Payment Type (Cash/ Bank/COD)",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "orderProgress.paymentType",
    width: 12
  }, {
    value: "Costing",
    style: (0, _objectSpread2.default)({}, fontBold),
    numFmt: '#,##0',
    prop: 'costing',
    width: 25
  }, {
    value: "Shipping charges by Shiratori",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: 'orderProgress.shippingChargeByShiratori',
    numFmt: '#,##0',
    width: 12
  }, {
    value: "Shipping charges by Customer",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: 'orderProgress.shippingChargeByCustomer',
    numFmt: '#,##0',
    width: 12
  }, {
    value: "Profit",
    style: (0, _objectSpread2.default)({}, fontBold),
    numFmt: '#,##0',
    prop: "productProfit",
    width: 25
  }, {
    value: "Customer Group",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "customer.customerGroup.name",
    width: 12
  }, {
    value: "Customer Rank",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "customer.customerRank.name",
    width: 12
  }, {
    value: "Customer from",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "customer.customerSource.name",
    width: 12
  }, {
    value: "Order Sale Channel",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "saleChannel.name",
    width: 12
  }, {
    value: "Published 正式な輸入商品 (有・無）",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "isPublished",
    width: 12
  }, {
    value: "Lot Number",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "lotNumber",
    width: 12
  }, type != ExportExcelType.Accountant && {
    value: "Tel",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "customer.phone",
    width: 12
  }, {
    value: "Address",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: 'customer.receiverAddress',
    width: 15,
    mergeCol: true,
    numberMergeCol: 4
  }, {
    value: "Address",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: 'customer.receiverWardName',
    width: 15
  }, {
    value: "Address",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: 'customer.receiverDistrictName',
    width: 15
  }, {
    value: "Address",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: 'customer.receiverCityName',
    width: 20
  }, {
    value: "Note",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: 'orderProgress.orderNote',
    width: 15
  }, {
    value: "Paid",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: 'paid',
    numFmt: '#,##0',
    width: 20
  }, {
    value: "Unpaid",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: 'unpaid',
    numFmt: '#,##0',
    width: 20
  }];
  var char = "A";
  var bulkChar = [];
  dataExcel = dataExcel.filter(function (e) {
    return !!e;
  });
  dataExcel.forEach(function (element) {
    var styleTotal = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, element.style), {}, {
      border: border,
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: {
          argb: 'ffff01'
        },
        bgColor: {
          argb: 'ffff01'
        }
      },
      font: {
        color: {
          argb: 'E21616'
        },
        bold: true
      },
      alignment: {
        wrapText: true,
        vertical: 'middle'
      }
    });
    var style = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, element.style), {}, {
      border: border,
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: {
          argb: 'ffff01'
        },
        bgColor: {
          argb: 'ffff01'
        }
      },
      alignment: {
        wrapText: true,
        vertical: 'middle',
        horizontal: 'center'
      }
    });
    var tmpChar = [].concat(bulkChar, [char]).join('');
    worksheet.getCell("".concat(tmpChar).concat(startRow)).value = element.value;
    if (char == 'O') {
      worksheet.getCell("".concat(char).concat(startRow)).style = styleTotal;
    } else {
      worksheet.getCell("".concat(tmpChar).concat(startRow)).style = style;
    }
    // if (element.mergeCol) {
    //   worksheet.mergeCells(`${tmpChar}${startRow}:${nextChar(char, element.numberMergeCol)}${startRow}`);
    // }
    row = startRow + 1;
    orders.forEach(function (order, index) {
      var fill = null;
      var font = null;
      if (order.type == _order.OrderType.Gift) {
        fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: {
            argb: 'c5e0b3'
          },
          bgColor: {
            argb: 'c5e0b3'
          }
        };
        font = fontBoldRed.font;
      }
      if (order.type == _order.OrderType.Consign) {
        fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: {
            argb: 'ffcc66'
          },
          bgColor: {
            argb: 'ffcc66'
          }
        };
        font = fontBoldRed.font;
      }
      var rowIndex = startRow + index + 1;
      worksheet.getRow(rowIndex).height = 50;
      worksheet.getCell("".concat(tmpChar).concat(rowIndex)).style = {
        border: border,
        alignment: {
          vertical: 'middle'
        },
        fill: fill,
        font: element.prop == 'customer.name' && font
      };
      element.numFmt && (worksheet.getCell("".concat(tmpChar).concat(rowIndex)).numFmt = element.numFmt);
      var value = (0, _index.generateProp)(order, element.prop, element.format);
      if (typeof value == 'boolean') {
        value = value ? "〇" : "X";
        worksheet.getCell("".concat(tmpChar).concat(rowIndex)).alignment = {
          vertical: 'middle',
          horizontal: 'center'
        };
      }
      if (order.discountType == 'amount') {
        worksheet.getCell("".concat(tmpChar).concat(rowIndex)).numFmt = '#,##0';
      }
      // if (element.mergeRow && order.rowspan) {
      //   worksheet.mergeCells(`${tmpChar}${rowIndex}:${tmpChar}${rowIndex - 1 + order.rowspan}`);
      // }
      if (element.prop == 'invoiceLink' && order.invoiceLink) {
        value = {
          formula: "HYPERLINK(\"".concat(value, "\", \"INVOICE LINK\")")
        };
      }
      if (order.code == 'Total') {
        worksheet.getCell("".concat(tmpChar).concat(rowIndex)).font = {
          bold: true
        };
        worksheet.getCell("".concat(tmpChar).concat(rowIndex)).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: {
            argb: 'ffff01'
          },
          bgColor: {
            argb: 'ffff01'
          }
        };
        if (element.prop == 'code') {
          worksheet.mergeCells("".concat(tmpChar).concat(rowIndex, ":").concat((0, _string.nextChar)(char, 4)).concat(rowIndex));
        }
      }
      worksheet.getCell("".concat(tmpChar).concat(rowIndex)).value = value;
      row = rowIndex;
    });
    if (char == "Z") {
      bulkChar.push('A');
      char = "A";
    } else {
      char = (0, _string.nextChar)(char);
    }
  });
  worksheet.columns.forEach(function (e, i) {
    if (dataExcel[i]) e.width = dataExcel[i].width;
  });
  generateTabelCollected(worksheet, collected, row + 2);
};
var generateTableSKU = function generateTableSKU(worksheet, data, startTableRow, type) {
  var orders = {};
  var total = 0;
  data.forEach(function (order) {
    var details = order.orderDetails || order.giveawayDetails;
    details.forEach(function (detail) {
      if ((type == ExportExcelType.Accountant || type == ExportExcelType.RealPublish) && !detail.isPublished) {
        return;
      }
      if (type != ExportExcelType.Accountant && order.type == _order.OrderType.Gift) {
        return;
      }
      if (type == ExportExcelType.RealNoPublish && detail.isPublished) {
        return;
      }
      if (orders[detail.product.sku]) {
        orders[detail.product.sku] += detail.quantity;
      } else {
        orders[detail.product.sku] = detail.quantity;
      }
      total += detail.quantity;
    });
  });
  orders["Total"] = total;
  var startRow = startTableRow;
  var dataExcel = [{
    value: "SKU",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "product.sku"
  }, {
    value: "Order quantity (box)",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "quantity",
    numFmt: '#,##0'
  }];
  var char = "D";
  dataExcel.forEach(function (element, indexCol) {
    worksheet.getCell("".concat(char).concat(startRow)).value = element.value;
    worksheet.getCell("".concat(char).concat(startRow)).style = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, element.style), {}, {
      border: border,
      alignment: {
        wrapText: true,
        vertical: 'middle'
      }
    });
    Object.entries(orders).forEach(function (order, index) {
      var rowIndex = startRow + index + 1;
      worksheet.getCell("".concat(char).concat(rowIndex)).style = {
        border: border,
        alignment: {
          vertical: 'middle'
        }
      };
      element.numFmt && (worksheet.getCell("".concat(char).concat(rowIndex)).numFmt = element.numFmt);
      worksheet.getCell("".concat(char).concat(rowIndex)).value = order[indexCol];
    });
    char = (0, _string.nextChar)(char);
  });
};
var generateTabelCollected = function generateTabelCollected(worksheet, data, startTableRow) {
  var startRow = startTableRow;
  var dataExcel = [{
    value: "Collected",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "collected",
    numFmt: '#,##0'
  }, {
    value: "Not collect",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "notCollected",
    numFmt: '#,##0'
  }, {
    value: "Total",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "totalCollected",
    numFmt: '#,##0'
  }];
  var char = "G";
  dataExcel.forEach(function (element) {
    worksheet.getCell("".concat(char).concat(startRow)).value = element.value;
    worksheet.getCell("".concat(char).concat(startRow)).style = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, element.style), {}, {
      border: border,
      alignment: {
        wrapText: true,
        vertical: 'middle'
      }
    });
    var rowIndex = startRow + 1;
    worksheet.getCell("".concat(char).concat(rowIndex)).style = {
      border: border,
      alignment: {
        vertical: 'middle'
      }
    };
    element.numFmt && (worksheet.getCell("".concat(char).concat(rowIndex)).numFmt = element.numFmt);
    worksheet.getCell("".concat(char).concat(rowIndex)).value = (0, _index.generateProp)(data, element.prop);
    char = (0, _string.nextChar)(char);
  });
};